import { faPlus } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import { UppercaseButton } from "../../../../Layout/Buttons/UppercaseButton";
import { IconWithRightMargin } from "../../../../Layout/Icons/IconWithRightMargin";
import { KENDO_BUTTON_CLASSES } from "../../../../Layout/Buttons/KendoButtons";

interface Props {
  readonly onClick: (items: any[]) => void;
  disabled?: boolean;
}

export default function CreateButton({ onClick, disabled }: Props) {
  async function handleClick(e: any) {
    onClick([
      {
        ImportDate: new Date(),
        LastModifiedDate: new Date(),
        UpdateMode: 0,
      },
    ]);
  }

  return (
    <UppercaseButton className={KENDO_BUTTON_CLASSES} onClick={(e) => handleClick(e)} disabled={disabled ?? false}>
      <IconWithRightMargin icon={faPlus} />
      ADD
    </UppercaseButton>
  );
}
